/* eslint-disable */
import { useState, useEffect, useMemo } from "react";
import { OLAPTransformerResult, useParameter, useDictionary, Column } from "../../../shared";
import Highcharts, { SeriesOptionsType } from "highcharts";
import { useChartOptions } from "../../../../charts/useChartOptions";
import { legendPipe, chartPipe, tooltipPipe, addXAxisPipe, addYAxisPipe } from "../../../../charts/pipes";
import { dictionaryService } from "../../../dataFlow";
import { arrayByLength, uniq } from "../../../../../shared";
import { last } from "lodash";
import { TableProps } from "../../../components/Table";
import { ColDef } from "ag-grid-community";
import { SLIDE_NUMBER } from "../constants";

const COLUMNS_AXIS = "calendar.default";
const ROWS_AXIS = "commodities.default";

export function useAgGridTransformer(olapData: OLAPTransformerResult | null): TableProps | undefined {
  const [state, setState] = useState<TableProps | undefined>();

  const [calendar] = useParameter<number[]>('@calendar');
  const [commodities] = useParameter<number[]>('@commodities');

  const columns = useMemo(() => {
    const currentColumn = { headerName: 'Current', field: 'current', resizable: true };
    const yearAgoColumn = { headerName: 'Year Ago', field: 'yearAgo', resizable: true };
    return [currentColumn, yearAgoColumn];
  }, []);

  useEffect(() => {
    if (olapData && calendar) {
      const [currentYear, lastYear] = [Math.max, Math.min].map(method => method(...calendar));

      const rows = commodities?.flatMap((commodity) => {
        const dataRow = olapData?.rows.find(row => Number(row.selection[ROWS_AXIS]) === commodity);
        let rowName = dataRow?.attributes[`${ROWS_AXIS}.name`][9] || '';
        let rowComment = dataRow?.attributes[`${ROWS_AXIS}.comment`] || '';

        const recordsRow = {
          type: 'data',
          Name: rowName,
          id: commodity,
        };

        const recordsCommentRow = {
          type: 'comment',
          Name: rowComment,
          id: commodity,
        };

        const [currentYearPoint, lastYearPoint] = [currentYear, lastYear].map(year =>
          dataRow?.points.find(point =>
            point.column.selection[COLUMNS_AXIS] === year
          )
        );

        recordsRow['current'] = currentYearPoint?.value === undefined ? '' : currentYearPoint?.value.toFixed(0);
        recordsRow['yearAgo'] = lastYearPoint?.value === undefined ? '' : lastYearPoint?.value.toFixed(0);

        return [recordsRow, recordsCommentRow];
      }) || [];

      const periodCol: ColDef = { headerName: "", field: "Name", resizable: true, width: 240 };
      const result: TableProps = {
        columns: [periodCol].concat(columns),
        rows,
        getRowClass: param => {
          const commodityIndex = commodities?.indexOf(param.data.id) || 0;
          const evenClass = (commodityIndex + 1) % 2 === 0 ? 'event-row' : '';
          const typeClass = param.data.type === 'comment' ? 'comment-row' : 'data-row';
          return [typeClass, evenClass].filter(Boolean).join(' ');
        },
      }

      setState(result);
    } else {
      setState(undefined);
    }
  }, [olapData, calendar, columns, commodities]);

  return state;
}
